import React from "react";
import { Modal, Button } from "react-bootstrap";

const EmergencyModal = ({ show, handleClose }) => {
  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title className="fw-bold">
          <i className="fas fa-feather-alt me-2 text-primary"></i>Found an
          Injured Bird?
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Stay calm. Your quick and gentle action can save a life. Follow these
          steps:
        </p>
        <ol>
          <li>
            <strong>Assess Safety:</strong> Ensure you are safe from traffic or
            other dangers before approaching the bird.
          </li>
          <li>
            <strong>Contain Gently:</strong> If safe, gently cover the bird with
            a light towel or cloth and place it in a well-ventilated cardboard
            box lined with a soft cloth. Keep it in a warm, dark, and quiet
            place.
          </li>
          <li>
            <strong>Do Not Feed or Water:</strong> This can cause more harm. The
            bird may be in shock.
          </li>
          <li>
            <strong>Call for Help Immediately:</strong> Contact our 24/7
            wildlife emergency hotline for advice.
          </li>
        </ol>
        <div className="text-center mt-4">
          <Button variant="danger" size="lg" href="tel:1800-WILDLIFE">
            <i className="fas fa-phone-volume me-2"></i>Call Our Hotline Now
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default EmergencyModal;
